import React, { useContext, useEffect } from 'react';
import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom';
import CryptoJS from 'crypto-js';
import toast from 'react-hot-toast';
import MainWrapper from '../MainWrapper';
import LogIn from '../../Account/LogIn';
import SignupAgent from '../../Account/SignupAgent/Index';
import ForgotPass from '../../Account/ForgotPass';
import WrappedRoutes from './WrappedRoutes';
import { AuthContext } from '../../../context/AuthContext';
import { GlobalContext } from '../../../context/GlobalContext';
import { Mealcontext } from '../../../context/MealContext';
import { PermissionContext } from '../../../context/PermissionContext';

const Router = () => {
  const { isLoggedIn, setIsLoggedIn, userId } = useContext(AuthContext);
  const { apiGlobalforlogin, apiGlobal } = useContext(GlobalContext);
  const { setclick, setActiveKey, setIsDetailsClick } = useContext(Mealcontext);
  const { setPermissionsAccess } = useContext(PermissionContext);

  const location = useLocation();
  const history = useHistory();

  const protectedPaths = [
    '/signup',
    '/forgot_password',
    '/',
    '/login',
    '/app_dashboard',
    '/dashboard',
    '/agent/meal',
    '/agent/account',
    '/agent/Profile',
    '/agent/booking',
    '/agent/trip',
    '/agent/payment/pending',
    '/agent/payment/approved',
    '/agent/payment/reject',
    '/usermanager/users',
    '/usermanager/manager',
  ];

  // Helper: Decrypt and load permissions from localStorage
  const decryptPermissions = () => {
    const encrypted = localStorage.getItem('permissions');
    if (!encrypted) return;

    try {
      const bytes = CryptoJS.AES.decrypt(
        encrypted,
        'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
      );
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      if (decrypted) {
        setPermissionsAccess(JSON.parse(decrypted));
      }
    } catch (error) {
      console.error('Permission decryption error:', error);
    }
  };

  // Helper: Logout logic
  const handleLogout = async () => {
    try {
      const res = await fetch(`${apiGlobalforlogin}/agent/logout.php`);
      const data = await res.json();

      if (data.loggedOut === true) {
        toast.success('Logout successful. Redirecting...');
        localStorage.clear();
        history.push('/');
        setIsLoggedIn(false);
      } else {
        toast.error('Logout failed. Try again.');
      }
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  // Helper: Block user via API
  const blockUser = async () => {
    if (!userId) return;

    const formData = new FormData();
    formData.append('user_id', userId);

    try {
      const res = await fetch(`${apiGlobal}agent/user_agent_block.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      console.log('User blocked:', data);
    } catch (err) {
      console.error('Block user error:', err);
    }
  };

  // On initial mount, check login status
  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        const res = await fetch(`${apiGlobalforlogin}/agent/auth.php`);
        const data = await res.json();

        setIsLoggedIn(data?.loggedIn);
        if (data?.loggedIn) {
          decryptPermissions();
        } else if (!data?.loggedIn) {
          localStorage.clear();
          sessionStorage.clear();
        
          // Clear Cookies
          document.cookie.split(';').forEach((cookie) => {
            const name = cookie.split('=')[0].trim();
            document.cookie = `${name }=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
          });
    
          if ('caches' in window) {
            caches.keys().then((names) => {
              // eslint-disable-next-line
              for (const name of names) {
                caches.delete(name);
              }
            });
          }
        }
      } catch (error) {
        console.error('Login check error:', error);
        setIsLoggedIn(false);
      }
    };

    checkLoginStatus();
  }, []);

  // Meal state cleanup on route change
  useEffect(() => {
    if (location.pathname !== '/agent/meal') {
      setActiveKey('1');
      setclick('searchSelect');
      setIsDetailsClick(false);
    }
  }, [location]);

  // Detect suspicious activity
  useEffect(() => {
    if (!protectedPaths.includes(location.pathname)) {
      // eslint-disable-next-line
      let count = parseInt(localStorage.getItem('erereddf')) || 0;
      count += 1;
      localStorage.setItem('erereddf', count.toString());

      if (count > 2) {
        handleLogout();
        blockUser();
      }
    }
  }, [location.pathname]);


  // if isLoggedIN is false then auto trigger handleLogout 
  // and clear local storage 
  // useEffect(() => {
  //   if (!isLoggedIn) {
  //     localStorage.clear();
  //     sessionStorage.clear();
    
  //     // Clear Cookies
  //     document.cookie.split(';').forEach((cookie) => {
  //       const name = cookie.split('=')[0].trim();
  //       document.cookie = `${name }=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  //     });

  //     if ('caches' in window) {
  //       caches.keys().then((names) => {
  //         // eslint-disable-next-line
  //         for (const name of names) {
  //           caches.delete(name);
  //         }
  //       });
  //     }
  //   }
  // }, []);

  return (
    <MainWrapper>
      <main>
        <Switch>
          <Route path="/signup" component={SignupAgent} />
          <Route path="/forgot_password" component={ForgotPass} />
          <Route path="/" component={isLoggedIn ? WrappedRoutes : LogIn} />

          <Route
            path="*"
            render={() => {
              if (!isLoggedIn) return <Redirect to="/" />;

              return protectedPaths.includes(location.pathname)
                ? <WrappedRoutes />
                : <WrappedRoutes currentPath={location.pathname} />;
            }}
          />
        </Switch>
      </main>
    </MainWrapper>
  );
};

export default Router;
